export const ORGANIZATION_LOAD_REQUEST = 'ORGANIZATION_LOAD_REQUEST';
export const ORGANIZATION_LOAD_SUCCESS = 'ORGANIZATION_LOAD_SUCCESS';
export const ORGANIZATION_LOAD_FAILURE = 'ORGANIZATION_LOAD_FAILURE';
export const ORGANIZATION_LOAD_DEFAULT = 'ORGANIZATION_LOAD_DEFAULT';
